/* eslint-disable indent */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import styled, { withTheme } from 'styled-components'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import ContactList from './ContactList'
import FootprintSurvey from './FootprintSurvey'
import FootprintReveal from './FootprintReveal'
import messages from './messages'
import InlineLoader from '../InlineLoader/InlineLoader'

const StyledModal = styled(Modal)`
  .modal-content {
    width: clamp(330px, 370px, 100%);
    background: var(--clr-bg-2);
  }
  .modal-header {
    padding: 30px 20px 0px 15px;
    border-bottom: none;

    button {
      padding: 6px 10px;
    }
  }
  h2.modal-title {
    text-transform: uppercase;
    font-size: var(--h6);
    padding: 10px 0px 0px 25px;
    color: var(--clr-grey-3-to-black);
    font-weight: 600;
    font-size: 16px;
  }
  .modal-body {
    text-align: center;
    color: var(--clr-grey-3-to-black);
    padding: 40px 15px;

    h3 {
      color: var(--clr-grey-4-to-white);
      font-size: var(--h5);
      font-weight: 700;
      padding-bottom: 40px;
    }
    p {
      font-size: var(--h6);
      padding: 20px 65px;
      margin: 0;
    }
    p + p {
      padding-bottom: 40px;
    }
  }
  .btn-copy {
    height: var(--button-height);
    width: 50px;
    margin-left: 5px;
    border: 1px solid var(--clr-accent);
    border-radius: var(--button-border-radius);
    background-color: var(--clr-accent);
    vertical-align: bottom;
  }
  .btn-copy:hover {
    border-color: var(--clr-text);
    background-color: var(--black);
  }
  .fa-clipboard {
    display: block;
    color: var(--clr-grey-1-to-white);
  }
  .modal-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    padding: 40px 15px;
    position: relative;

    hr {
      height: 1px;
      width: 90%;
      position: absolute;
      top: 0;
      left: 0;
      background: var(--clr-grey-6-to-grey-1);
      margin: 0 5%;
    }

    button {
      flex-basis: 150px;
      height: var(--button-height);
      border-color: var(--clr-grey-6-to-grey-1);
      background: var(--clr-white-to-black);
      color: var(--clr-grey-3-to-white);
      border-radius: var(--button-border-radius);
      padding: 5px;
      font-weight: 600;
      font-size: 16px;
      text-transform: uppercase;

      &:hover {
        background-color: var(--clr-accent-to-grey-3);
        color: var(--white);
      }
    }
  }

  .CollapsibleContacts__trigger {
    color: var(--clr-grey-3-to-text);
    display: block;
    text-decoration: underline;
    cursor: pointer;
    position: relative;
    padding: 25px 0px 0px 0px;
  }
  .form-group {
    margin: 0 25px;
  }
  .form-control {
    margin-bottom: 10px;
    border-color: var(--clr-btn);
    background: var(--clr-white-to-grey-0);
    height: var(--button-height);
  }
  .react-phone-number-input__phone,
  .rrui__select__selected {
    border: none;
    width: 100%;
  }
  .rrui__select {
    display: none;
  }
  .react-phone-number-input__icon {
    vertical-align: sub;
  }
  .form-group .btn {
    margin: 10px 0;
    background-color: var(--clr-btn);
    border-color: var(--clr-btn);
  }

  .error {
    font-size: 11px;
    color: #f00;
    text-align: left;
  }
  .footprint-id {
    font-size: 40px;
    color: var(--clr-accent);
  }
  #phoneNumber {
    background: var(--clr-white-to-grey-0);
    height: 100%;
  }
`

const ContactUsModal = ({
  showAll,
  show,
  onHide,
  help = false,
  language,
  contactOptions,
  preSaleFlag,
  createUserEvent,
  displayComponent,
  updateDisplayComponent,
  createFootprint,
  footprintId,
  contactConfig
}) => {
  const [footprintOption, setFootprintOption] = useState(null)
  const translated = messages[language]
  const styles = {}

  const resetAndClose = () => {
    createUserEvent({
      category: 'navigation',
      data: { link_to: '#contact', source: 'ContactExit' }
    })
    updateDisplayComponent('list')
    setFootprintOption(null)
    onHide()
  }

  const showFootprintForm = option => {
    updateDisplayComponent('footprintForm')
    setFootprintOption(option)
  }

  return (
    <StyledModal
      key={2}
      onHide={resetAndClose}
      show={show}
      bsSize="small"
      dialogClassName="db-font-override"
      backdrop="static"
      id="contact-us-body"
    >
      <Modal.Header closeButton>
        <Modal.Title componentClass="h2">{translated.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        {displayComponent === 'list' ? (
          <ContactList
            showAll={showAll}
            help={help}
            contactOptions={contactOptions}
            preSaleFlag={preSaleFlag}
            createUserEvent={createUserEvent}
            showFootprintForm={showFootprintForm}
            contactConfig={contactConfig}
            resetAndClose={resetAndClose}
          />
        ) : displayComponent === 'footprintForm' ? (
          <FootprintSurvey
            createFootprint={createFootprint}
            language={language}
          />
        ) : displayComponent === 'footprintReveal' ||
          displayComponent === 'loading' ? (
          <FootprintReveal
            footprintId={footprintId}
            contactOption={footprintOption}
            loading={displayComponent === 'loading'}
            createUserEvent={createUserEvent}
          />
        ) : (
          <InlineLoader style={styles} />
        )}
      </Modal.Body>
      <Modal.Footer>
        <hr />
        <Button onClick={resetAndClose}>{translated.close}</Button>
      </Modal.Footer>
    </StyledModal>
  )
}

ContactUsModal.propTypes = {
  help: PropTypes.bool,
  language: PropTypes.string,
  contactOptions: PropTypes.array.isRequired,
  preSaleFlag: PropTypes.bool,
  createUserEvent: PropTypes.func,
  displayComponent: PropTypes.string,
  updateDisplayComponent: PropTypes.func,
  createFootprint: PropTypes.func,
  footprintId: PropTypes.string,
  contactConfig: PropTypes.string
}

export default withTheme(LanguageProvider(ContactUsModal))



// WEBPACK FOOTER //
// ./src/components/ContactUsModal/ContactUsModal.js